export class DadosRenovaModel {
    
    public  numInscricao: string; 
	
	public  autoridadeCertificadora: string;
	public  coSerial: string;
	public  numeroPerfil: string;

	public p002rDataChancela: string;
	public p002rImagemChancela: string;
	public p002rImagemAssinatura;
	public p002rImagemAssinaturaSistema;

	public  p002nTipoChancela: string;
	public p002nDataChancela: string;
	public p002nImagemChancela: string;
	public p002nImagemAssinatura;
	public p002nImagemAssinaturaSistema;
	
	public  p003TipoContrato: string;
	public  p003UltimoTipoChancela: string;
	public  p003DataUltimaChancela: string;
	
	public  servicos: number[];
}